import React from 'react';
import PropTypes from 'prop-types';

export default function ConfirmPassword({
  Field, Err, useInput, errors, password,
}) {
  return (
    <React.Fragment>
      <Field
        type="password"
        placeholder="confirm password"
        {...useInput('passwordVerification', {
          isRequired: true,
          equals: password,
        })}
      />
      {!!errors.passwordVerification && (
        <Err>
          {{
            isRequired: 'Confirm password is required',
            equals: 'Passwords must match',
          }[errors.passwordVerification]}
        </Err>
      )}
    </React.Fragment>
  );
}

ConfirmPassword.propTypes = {
  Field: PropTypes.elementType.isRequired,
  Err: PropTypes.elementType.isRequired,
  useInput: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    passwordVerification: PropTypes.string,
  }),
  password: PropTypes.string,
};

ConfirmPassword.defaultProps = {
  errors: { passwordVerificatio: null },
  password: null,
};
